/* eslint-disable */
import { combineReducers, } from 'redux';

import statusBarCheckout from './statusBarCheckout';

export default combineReducers({
  statusBarCheckout,
});